module.exports = __webpack_public_path__ + "media/common/icon-segment-6d2d1199.svg";